import {
  succubus_sequences_SequencesManager,
  succubus_sequences_utils_ElementColumns } from "./sequencesmanagertypes.d.ts";

const sequences = window?.succubus?.sequences
const sm = sequences?.SequencesManager

export const available = () => sm !== undefined

if(available()) {
  sm.init()
}

/** @type {succubus_sequences_SequencesManager} */
export default sm?.instance

/** @type {succubus_sequences_utils_ElementColumns} */
export const ElementColumns = sequences?.utils?.ElementColumns
